<!--
    校区管理-员工管理
    功能：展示/新增员工列表信息，根据是否年服务可配置[作课上课]权限、统计上课权限账号数
    说明：添加版本3.0需求
-->
<template>
  <div
    v-if="show"
    class="staff">
    <!--
      excelLabel="批量导入"
      downloadLabel="导出模板"-->
    <AppList
      ref="list"
      :list.sync="list"
      :create-label="$permissions('school_admin_staff_add') ? '新增员工' : ''"
      :skip-label="schoolInfo.vip_type!==2&&schoolInfo.vip_expired&&'开通年服务'"
      :api="apiUrl"
      :api-type="apiUrl"
      title=""
      @create="toCreate"
      @skipPage="openService">
      <AppSearch
        slot="search"
        :order="{ type: 'id', name: 'desc'}"
        :search-arr="searchArr"/>
      <template slot-scope="props">
        <p style="margin-top:-10px;color:red">当前拥有作课上课权限的账号数为：{{ schoolInfo.user_count }} | 已开启：{{ isAuthNum }}</p>
        <el-table
          :data="props.listData">
          <el-table-column
            width="80px"
            label="头像">
            <template slot-scope="scope">
              <img
                :src="scope.row.headimgurl ? scope.row.headimgurl : ''"
                :onerror="scope.row.gender === 1 ? moveErrorMan : moveErrorWomen"
                class="head_url"
                alt="">
            </template>
          </el-table-column>
          <el-table-column
            v-for="column in columns"
            v-if="!column.show"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :formatter="column.formatter"
          />
          <el-table-column
            v-if="$permissions('school_admin_staff_courseMake')"
            width="120px"
            label="作课上课权限"
          >
            <template slot-scope="{row}">
              <span v-if="row.enable_courseware_use === 1">开启</span>
              <span v-else>关闭</span>
              <el-switch
                :value="row.enable_courseware_use === 1"
                active-color="#13ce66"
                inactive-color="#e3e3e3"
                @change="switchCourseMake(row)"/>
            </template>
          </el-table-column>
          <el-table-column
            v-if="$permissions('school_admin_staff_status')"
            width="100px"
            label="是否禁用">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1">{{ scope.row.status_text }}</span>
              <span v-else>{{ scope.row.status_text }}</span>
              <el-switch
                :value="scope.row.status === 1"
                :disabled="scope.row.uuid === $store.state.choicesSchool.main_id"
                active-color="#13ce66"
                inactive-color="#e3e3e3"
                @change="switchStatus(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="250px"
            class="orgin-btn"
          >
            <template slot-scope="scope">
              <template v-if="$store.state.from === 'schoolCenter'">
                <el-link
                  v-if="$permissions('school_admin_staff_reset')"
                  size="small"
                  @click="resetPassword(scope.row)"
                >重置密码</el-link>
                <i class="icon-splite">|</i>
                <el-link
                  v-if="$permissions('school_admin_staff_edit')"
                  size="small"
                  @click="edit(scope.row)"
                >编辑</el-link>
              </template>
              <template v-else>
                <el-button
                  v-if="$permissions('school_admin_staff_reset')"
                  size="small"
                  @click="resetPassword(scope.row)"
                >重置密码</el-button>
                <el-button
                  v-if="$permissions('school_admin_staff_edit')"
                  size="small"
                  @click="edit(scope.row)"
                >编辑</el-button>
                <!--              <el-button-->
                <!--                size="small"-->
                <!--                type="danger"-->
                <!--                plain-->
                <!--                @click="del(scope.row.id)"-->
                <!--              >删除</el-button>-->
              </template>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>
    <el-dialog
      :title="dialogTitle === 'add' ? '新增员工': '修改员工'"
      :visible.sync="formDialogVisible"
      width="1000px">
      <el-form
        ref="form"
        :rules="rules"
        :model="formData"
        label-width="125px">
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="真实姓名："
              prop="name">
              <el-input
                v-model="formData.name"
                :maxlength="20"
                placeholder="请输入真实姓名"/>
            </el-form-item>
            <el-form-item
              v-if="roleList"
              label="角色："
              prop="role_ids">
              <el-checkbox-group
                :disabled="dialogTitle!=='add'"
                v-model="formData.role_ids">
                <el-checkbox
                  v-for="(item, index) in roleList"
                  v-show="item.id !== 4 && item.id !== 5"
                  :key="index"
                  :label="item.id">
                  {{ item.name }}
                </el-checkbox>
              </el-checkbox-group>
              <!--              <el-popover-->
              <!--                placement="right"-->
              <!--                width="500"-->
              <!--                trigger="click">-->
              <!--                <i slot="reference" class="el-icon-question"></i>-->
              <!--                <p>这是一段内容,这是一段内容,这是一段内容,这是一段内容。这是一段内容,这是一段内容,这是一段内容,这是一段内容。</p>-->
              <!--              </el-popover>-->
            </el-form-item>
            <!-- <el-form-item
              v-if="$permissions('school_admin_staff_courseMake')"
              label="课程制作权限："
              prop="is_course_make">
              <el-switch
                v-model="formData.is_course_make"
                :active-value="1"
                :inactive-value="2"
                active-color="#13ce66"
                inactive-color="#e3e3e3"/>
              <span>{{ formData.is_course_make === 1 ? '开启' : '关闭' }}</span>
            </el-form-item>
            <el-form-item
              v-if="$permissions('school_admin_staff_courseMake')"
              label="："
              prop="is_course_make">
              <el-switch
                v-model="formData.is_course_make"
                :active-value="1"
                :inactive-value="2"
                active-color="#13ce66"
                inactive-color="#e3e3e3"/>
              <span>{{ formData.is_course_make === 1 ? '开启' : '关闭' }}</span>
            </el-form-item> -->
            <el-form-item
              label="联系电话："
              prop="mobile">
              <el-input
                :disabled="dialogTitle!=='add'"
                v-model.trim="formData.mobile"
                placeholder="请输入联系电话"
                @input="val => formData.mobile = val.replace(/[^\d]/g, '').slice(0, 11)"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="真实头像："
              class="headimgurl">
              <AppUploadScale
                v-model="formData.headimgurl"
                class="form_img"
                @on-success="getThumbnailrUrl" />
            </el-form-item>
            <el-form-item
              label="性别："
              prop="gender">
              <el-radio
                v-model="formData.gender"
                :label="1">男</el-radio>
              <el-radio
                v-model="formData.gender"
                :label="2">女</el-radio>
            </el-form-item>
            <el-form-item label="邮箱：">
              <el-input
                v-model="formData.email"
                placeholder="请输入邮箱"/>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="tips">
          <div class="left">温馨提醒：</div>
          <div class="right">
            <p>老师使用手机号登录后台和直播端。</p>
            <p>初始密码：a123456</p>
            <p>初始密码较为简单，老师需登录后台修改密码哦！</p>
          </div>
        </div>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="formDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitStaff">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 开通年服务 -->
    <open-service
      v-if="openServiceDailog"
      :visible.sync="openServiceDailog"/>
    <!-- 扩展账号 -->
    <open-limit
      v-if="openLimitDailog"
      :visible.sync="openLimitDailog"/>
  </div>
</template>

<script>
import Vue from 'vue';
import list from '@/mixins/list';
import baseUrl from '../../utils/api';
import defaultMan from '@/assets/images/staff_man.png';
import defaultWomen from '@/assets/images/staff_women.png';
import openService from './components/openService.vue';
import openLimit from './components/openLimit.vue';

export default {
  name: 'Staff',
  inject: ['reload'],
  components: {
    openService,
    openLimit,
  },
  mixins: [list],
  data() {
    return {
      show: true,
      list: {},
      formDialogVisible: false,
      moveErrorMan: `this.src="${defaultMan}"`,
      moveErrorWomen: `this.src="${defaultWomen}"`,
      form: {
        name: '', // 姓名
        role_ids: [], // 角色id
        role_text: [], // 角色名称
        is_course_make: 2, // 作课上课权限 // 1=开启；2=不开启
        mobile: '', // 电话
        headimgurl: '', // 头像
        gender: 1, // 性别
        email: '', // 邮箱
      },
      formData: {
        mobile: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        role_ids: [
          { required: true, message: '请选择角色' },
        ],
        is_course_make: [
          { required: true, message: '请选择课程制作权限' },
        ],
        mobile: [
          this.$rules.required('手机号'), { ...this.$rules.mobile },
        ],
        gender: [
          { required: true, message: '请选择性别' },
        ],
      },
      dialogTitle: '',
      columns: [{ prop: 'name', label: '员工姓名' },
        {
          label: '角色',
          formatter: (row) => {
            if (row.role_text.length > 0) {
              const data = [];
              row.role_text.forEach((item) => {
                data.push(...this.roleList.filter(i => i.id === item.role_id));
              });
              return data.map(item => item.name).join('，');
            }
            return '--';
          },
        },
        {
          label: '校区',
          formatter: () => this.choicesSchool.name,
        },
        {
          label: '性别',
          width: '80px',
          formatter: row => (row.gender === 1 ? '男' : '女'),
        },
        { prop: 'mobile', label: '联系电话', width: '120px' },
        { prop: 'email', label: '邮箱', width: '200px' },
        { prop: 'created_at', label: '注册时间', width: '160px' }],
      isCreated: true,
      roleList: [],
      openServiceDailog: false, // 年服务弹窗
      openLimitDailog: false, // 账号扩充窗口
      noVip: false, // 非vip
      isAuthNum: null,
      apiUrl: '/api/staff?order[created_at]=desc',
      isServe: false, // 是否在服务内
      schoolInfo: null, // 校区信息
    };
  },
  computed: {
    choicesSchool() {
      return this.$store.state.choicesSchool;
    },
    user() {
      return this.$store.state.user;
    },
    searchArr() {
      const column = [
        { prop: 'name', label: '员工姓名' },
        { prop: 'mobile', label: '联系电话' },
        { prop: 'email', label: '邮箱' },
      ];
      return [
        {
          selectValue: this.roleList ? this.roleList.map(item => ({ value: item.id, name: item.name })) : [],
          componentType: 'AppSearchStatus',
          searchType: 'role_id',
          placeholder: '请选择角色',
        },
        { componentType: 'AppSearchColumn', searchType: column },
      ];
    },
  },
  watch: {
    roleList() {
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    '$store.state.schoolInfo': {
      handler(vl) {
        this.schoolInfo = vl;
        // if (vl) {
        //   if (vl.vip_type === 2 && !vl.vip_expired) { // 服务内
        //     this.noVip = false;
        //   } else {
        //     this.noVip = true;
        //   }
        // }
        if (vl.is_try_vip === 1) { // 体验期
          this.isServe = true;
        } else if (vl.vip_type === 2) { // 服务期
          this.isServe = !vl.vip_expired;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      await this.getCoursewareCount();
      this.showInit = true;
      this.formData = this.form;

      const data = [{ id: 4, name: '校长' }, { id: 5, name: '主体账号' }];

      if (this.$store.state.roleList) {
        this.roleList = [...data, ...this.$store.state.roleList];
      } else {
        this.$http.get('/api/role').then((res) => {
          this.roleList = [...data, ...res.items];
          this.$store.state.roleList = res.items;
        });
      }
    },
    getCoursewareCount() {
      this.$http.get('/api/staff/enable_courseware_use_count').then((res) => {
        // eslint-disable-next-line no-cond-assign
        if (res.status_code === 200) {
          this.isAuthNum = res.data.enable_courseware_use_count;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 开通年服务
    openService() {
      this.$confirm('若需开通年服务，请联系运营人员进行开通！', '提示', {
        confirmButtonText: '关闭',
        showCancelButton: false,
        type: 'warning',
      }).then(() => {}).catch(() => {});
    },
    // 新增员工按钮
    toCreate() {
      this.formDialogVisible = true;
      this.dialogTitle = 'add';
      this.formData = this.form;
    },
    // 编辑员工按钮
    edit(row) {
      this.formDialogVisible = true;
      this.formData = {
        ...row,
        role_ids: row.role_text.map(item => item.role_id),
      };
      this.dialogTitle = 'edit';
    },
    // 删除员工按钮
    del(id) {
      this.$confirm('是否删除员工?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http.delete(`/api/staff/${id}`)
          .then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            this.reload();
          })
          .catch((err) => {
            this.$message.error(err.message);
          });
      });
    },
    // 修改课程权限
    switchCourseMake(row) {
      if (!this.isServe) {
        // this.$confirm('请先开通校区年服务', '提示', {
        //   confirmButtonText: '确定去开通',
        //   cancelButtonText: '取消',
        //   type: 'warning',
        // }).then(() => {
        //   this.openServiceDailog = true;
        // }).catch(() => {
        // });
        this.$confirm('请先开通校区年服务，请联系运营人员进行开通！', '提示', {
          confirmButtonText: '关闭',
          showCancelButton: false,
          type: 'warning',
        }).then(() => {}).catch(() => {});
      } else if (this.isAuthNum === this.schoolInfo.user_count && row.enable_courseware_use !== 1) {
        // this.$confirm('校区作课上课账号数已达上限，请进行扩充购买', '提示', {
        //   confirmButtonText: '确定去购买',
        //   cancelButtonText: '取消',
        //   type: 'warning',
        // }).then(() => {
        //   this.openLimitDailog = true;
        // }).catch(() => {
        //   console.log('已取消');
        // });
        this.$confirm('校区作课上课账号数已达上限，请联系运营人员进行扩充！', '提示', {
          confirmButtonText: '关闭',
          showCancelButton: false,
          type: 'warning',
        }).then(() => {}).catch(() => {});
      } else {
        const enable_courseware_use = {
          enable_courseware_use: row.enable_courseware_use === 1 ? 0 : 1,
        };
        this.$confirm('确定修改课程权限吗', '提示', {
          showCancelButton: true,
          type: 'warning',
          confirmButtonText: '确定',
        })
          .then(() => {
            this.$http
              .patch(`/api/staff/${row.id}/enable_courseware_use`, enable_courseware_use)
              .then((res) => {
                if (res.status_code === 200) {
                  this.$message.success('状态修改成功');
                  this.getCoursewareCount();
                  this.reload();
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch((err) => {
                this.$message.error(err.message);
              });
          });
      }
    },
    // 修改禁用状态
    switchStatus(row) {
      const status = {
        status: row.status === 1 ? 2 : 1,
      };
      this.$confirm('确定修改状态吗', '确认', {
        showCancelButton: true,
        type: 'success',
        confirmButtonText: '确定',
        confirmButtonClass: 'el-button--success',
      })
        .then(() => {
          this.$http
            .patch(`/api/staff/${row.id}/status`, status)
            .then((res) => {
              this.$message.success('状态修改成功');
              this.reload();
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        });
    },
    // 重置密码
    resetPassword(row) {
      this.$confirm('是否要重置密码?', '提示', {
        confirmButtonText: '重置',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const data = {
          password: 'a123456',
        };
        this.$http
          .patch(`${baseUrl}/api/users/${row.uuid}/password/new`, data)
          .then((res) => {
            this.$alert('初始密码：a123456', '重置成功！');
            this.reload();
          })
          .catch((err) => {
            this.$message.error(err.message);
          });
      });
    },
    // 上传图片
    getThumbnailrUrl(url) {
      this.$nextTick(() => {
        this.formData.headimgurl = url;
      });
      this.$forceUpdate();
    },
    // 提交新增员工
    submitStaff() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.isCreated) {
            if (this.dialogTitle === 'add') {
              // 新增
              this.isCreated = false;
              this.$http.post('/api/staff', this.formData)
                .then(() => {
                  this.isCreated = true;
                  this.$message.success('保存成功');
                  this.formDialogVisible = false;
                  this.reload();
                })
                .catch((err) => {
                  this.isCreated = true;
                  this.$message.error(err.message);
                });
            } else {
              // 修改
              this.$http.put(`/api/staff/${this.formData.id}`, this.formData)
                .then(() => {
                  this.isCreated = true;
                  this.$message.success('保存成功');
                  this.formDialogVisible = false;
                  this.reload();
                })
                .catch((err) => {
                  this.isCreated = true;
                  this.$message.error(err.message);
                });
            }
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.staff {
  .form_img {
    width: 100px;
    height: 100px;
  }
  .tips{
    display: flex;
    font-size: 12px;
    color: red;
    .left {
      flex: 0 0 125px;
      text-align: right;
      line-height: 20px;
    }
    .right {
      p {
        margin: 0;
        line-height: 20px;
      }
    }
  }
  .headimgurl {
    margin-bottom: 9px;
  }
  .el-checkbox-group {
    display: inline-block;
    .el-checkbox {
      margin-right: 5px;
    }
  }
  .el-icon-question {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    font-size: 18px;
    color: var(--color-primary);
  }
  .head_url {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Staff/index.vue